import { marqueeVerses } from "../../data/content";

const Marquee = () => {
    const items = [...marqueeVerses, ...marqueeVerses];
    return (
        <section
            data-testid="marquee-section"
            aria-label="Versos en movimiento"
            className="border-y border-line bg-cream py-7 overflow-hidden"
        >
            <div className="flex w-max animate-marquee hover:[animation-play-state:paused]">
                {items.map((verse, i) => (
                    <div key={i} className="flex items-center shrink-0">
                        <span className="font-display italic text-xl sm:text-2xl text-ink/80 whitespace-nowrap px-8">
                            {verse}
                        </span>
                        <span className="font-mono text-crimson text-xs">✳</span>
                    </div>
                ))}
            </div>
        </section>
    );
};

export default Marquee;
